import { useEffect, useState } from 'react';
// Libs
import Image from 'next/image';

import clsx from 'clsx';
import { motion } from 'framer-motion';

import jellyco_blue from '../../../../../../../public/images/giveaway-picker/Jellycos/jellyco_blue.png';
// Images
import jellyco_orange from '../../../../../../../public/images/giveaway-picker/Jellycos/jellyco_orange.png';
import jellyco_purple from '../../../../../../../public/images/giveaway-picker/Jellycos/jellyco_purple.png';
import jellyco_red from '../../../../../../../public/images/giveaway-picker/Jellycos/jellyco_red.png';
import jellyco_yellow from '../../../../../../../public/images/giveaway-picker/Jellycos/jellyco_yellow.png';

const jellycoImages = [
    { name: 'orange', src: jellyco_orange },
    { name: 'blue', src: jellyco_blue },
    { name: 'yellow', src: jellyco_yellow },
    { name: 'purple', src: jellyco_purple },
    { name: 'red', src: jellyco_red }
];

const positions = [-160, -90, 0, 90, 160];

const sizeVariants = {
    small: { width: 40, height: 40 },
    medium: { width: 60, height: 60 },
    large: { width: 80, height: 80 }
} as const;

type SizeVariant = keyof typeof sizeVariants;

const getSize = (adjustedIndex: number): SizeVariant => {
    if (adjustedIndex === 2) return 'large';
    if (adjustedIndex === 1 || adjustedIndex === 3) return 'medium';
    return 'small';
};

const getZIndex = (adjustedIndex: number) => {
    if (adjustedIndex === 2) return 'z-30';
    if (adjustedIndex === 1 || adjustedIndex === 3) return 'z-20';
    return 'z-10';
};

export const JellycoLoader = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % 5);
        }, 2000);
        return () => clearInterval(intervalId);
    }, []);

    return (
        <motion.div
            className="relative flex h-36 w-125 items-center justify-center overflow-hidden py-8"
            style={{
                background: 'linear-gradient(90deg, #FFF 0%, #F6F8FB 50.08%, #FFF 100%)'
            }}
            data-testid="jellyco-loader">
            {positions.map((position, index) => {
                const adjustedIndex = (index - currentIndex + 5) % 5;
                const size = getSize(adjustedIndex);
                const zIndex = getZIndex(adjustedIndex);
                const jellyco = jellycoImages[index];

                const imageContent = (
                    <Image src={jellyco.src} alt={`Jellyco ${jellyco.name}`} layout="fill" />
                );

                return (
                    <motion.div
                        key={jellyco.name}
                        className={clsx('absolute', zIndex)}
                        style={{ x: position }}
                        animate={{
                            x: positions[(index - currentIndex + 5) % 5],
                            ...sizeVariants[size]
                        }}
                        transition={{ type: 'spring', stiffness: 120, damping: 20, bounce: 10 }}>
                        {adjustedIndex === 2 ? (
                            <div className="relative h-full w-full p-8">
                                <div className="absolute inset-0 -m-1.25 rounded-2xl border-2 border-icoBlue outline outline-4 outline-icoBlue-200"></div>
                                {imageContent}
                            </div>
                        ) : (
                            imageContent
                        )}
                    </motion.div>
                );
            })}
        </motion.div>
    );
};
